import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Dropdown } from 'semantic-ui-react'
import { isArray } from 'lodash'
import WidgetRegistry from '../widgets'
import { parseWidgetOptionsFromRegistry } from '../widgets/utils'
import './flex-grid.css'


class FlexGrid extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nodes: {},
      widgetOptions: parseWidgetOptionsFromRegistry(),
      hoveredElement: -1,
    }
  }

  // just numbers in the grid, adding/removing cells
  // dropdowns for widget assignment, adding/removing cells
  // actual widgets render, editing controls

  // preview === just numbers in the grid
  // preview && useWidgetRegistry === widget dropdown which edits
  // editing === edit controls for widgets
  // can either be editing or preview

  handleRef = (idxPath) => (node) => {
    if (!this.state.nodes[idxPath]) {
      const nodes = { ...this.state.nodes, [idxPath]: node }
      this.setState({ nodes })
    }
  }

  toggleClass(idx, value) {
    this.setState({ hoveredElement: value ? idx.join('') : -1 })
  }

  renderGridControl = (idx, isRow, isParent = false, isRoot = false) => {
    let className = 'editGridControls'
    if (isRoot) {
      className += ' rootControl'
    } else if (isParent) {
      if (isRow) {
        className += ' parentRow'
      } else {
        className += ' parentCol'
      }
    } else if (isRow) {
      className += ' elementRow'
    } else {
      className += ' elementCol'
    }

    return (
      <div
        onMouseEnter={() => this.toggleClass(idx, true)}
        onMouseLeave={() => this.toggleClass(idx, false)}
        className={className}
      >
        <button
          className="gridControl remove"
          onClick={() => this.props.editGridLayout(idx, 'remove')}
        >
          -
        </button>
        <button
          className="gridControl add"
          onClick={() => this.props.editGridLayout(idx)}
        >
          +
        </button>
      </div>
    )
  }

  outputGridElement = (parentIsRow, ele, idxPath, width = false) => {
    const {
      preview,
      useWidgetRegistry,
      data,
      config,
      editGridConfig,
      editing,
      inPlaceEdit,
      padded,
    } = this.props

    let child = ele
    // default to displaying the element
    if (preview) {
      if (!useWidgetRegistry) {
        child = <div>{JSON.stringify(ele)}</div>
      } else {
        // edit functions
        child = (
          <Dropdown
            className="widgetDropdown"
            selection
            options={this.state.widgetOptions}
            value={ele.widget}
            // onChange={(e, { value })=> this.onDataSelect(idx, value, 'widget')}
            onChange={(e, { value }) => this.props.editGridWidget(idxPath, value, 'widget')}
          />
        )
      }
    } else if (useWidgetRegistry && !isArray(ele)) {
      // render the widget
      if (ele.widget) {
        // data is array representing path -> [key1, key2, key3]
        const widgetData = data
        // //handle multiple data sources!
        // ele.data.forEach(key => {
        //  if(key !== -1){
        //    widgetData = widgetData[key]
        //  }
        // })
        const thisWidget = WidgetRegistry[ele.widget]
        if (thisWidget) {
          child = thisWidget({
            data: widgetData,
            config: config[idxPath.join('')],
            editGridConfig: editGridConfig(idxPath.join('')),
            editing,
          })
        } else {
          child = 'Need Widget to render'
        }
      } else {
        child = 'Need Widget to render'
      }
    }

    let className = preview ? 'editCell' : ''
    if (idxPath.join('') === this.state.hoveredElement) {
      className += ' hoveredElement'
    }
    const style = {}
    if (!padded) {
      style.padding = 0
    }
    if (parentIsRow) {
      return (
        <Grid.Column
          className={className}
          width={width}
          stretched={!preview}
          key={idxPath[idxPath.length - 1]}
          style={style}
        >
          {
            isArray(ele) ? (
              <Grid centered>
                {
                  ele.map((childEle, i) => this.outputGridElement(!parentIsRow, childEle, idxPath.concat(i)))
                }

                {preview && inPlaceEdit && this.renderGridControl(idxPath, !parentIsRow, true)}
              </Grid>
            ) : (
              <>
                {child}
                {preview && inPlaceEdit && this.renderGridControl(idxPath, !parentIsRow)}
              </>
            )
          }
        </Grid.Column>
      )
    }
    return (
      <Grid.Row
        className={className}
        columns={isArray(ele) ? ele.length : null}
        stretched={!preview}
        centered
        key={idxPath[idxPath.length - 1]}
      >
        {
          isArray(ele)
            ? (
              <>
                {ele.map((childEle, i) => this.outputGridElement(
                  !parentIsRow,
                  childEle,
                  idxPath.concat(i),
                  Math.floor(16 / ele.length),
                ))}
                {preview && inPlaceEdit && this.renderGridControl(idxPath, !parentIsRow, true)}
              </>
            )
            : (
              <>
                {child}
                {preview && inPlaceEdit && this.renderGridControl(idxPath, !parentIsRow)}
              </>
            )
        }
      </Grid.Row>
    )
  }

  render() {
    const {
      preview,
      gridArray,
      celled,
      divided,
      inPlaceEdit,
    } = this.props

    let className = ''
    if (this.state.hoveredElement === '') {
      className += 'hoveredElement'
    }
    return (
      <Grid
        celled={celled}
        divided={divided}
        className={className}
        centered
      >
        {gridArray.map((ele, i) => this.outputGridElement(false, ele, [i]))}
        {preview && inPlaceEdit && this.renderGridControl([], false, false, true)}
      </Grid>
    )
  }
}

FlexGrid.propTypes = {
  gridArray: PropTypes.array.isRequired,
  data: PropTypes.object,
  config: PropTypes.object,
  editGridConfig: PropTypes.func,
  editGridWidget: PropTypes.func,
  editGridLayout: PropTypes.func,
  preview: PropTypes.bool,
  inPlaceEdit: PropTypes.bool,
  editing: PropTypes.bool,
  useWidgetRegistry: PropTypes.bool,
  celled: PropTypes.bool,
  divided: PropTypes.bool,
  padded: PropTypes.bool,
}

FlexGrid.defaultProps = {
  data: {},
  config: {},
  editGridConfig: () => {},
  editGridWidget: () => {},
  editGridLayout: () => {},
  editing: false,
  preview: false,
  inPlaceEdit: true,
  useWidgetRegistry: true,
  celled: false,
  divided: false,
  padded: true,
}

export default FlexGrid
